<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/player' }">
        <app-i18n code="entities.player.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.player.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.player.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <app-back-button
      route-name="subpropertyPeople"
      :route-params="{ tabName: 'players' }"
      i18n-code="entities.player.label"
    />

    <h1 class="app-content-title app-content-title--hidden">
      <app-i18n code="entities.player.edit.title" v-if="isEditing"></app-i18n>
      <app-i18n code="entities.player.new.title" v-if="!isEditing"></app-i18n>
    </h1>
    
    <div class="app-content-page">
      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :disabled="true" v-model="model[fields.id.name]"/>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.teams.label"
          :prop="fields.teams.name"
          :required="fields.teams.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-many-input
              :fetchFn="fields.teams.fetchFn"
              v-model="model[fields.teams.name]"
            ></app-autocomplete-many-input>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.firstName.label"
          :prop="fields.firstName.name"
          :required="fields.firstName.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.firstName.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.lastName.label"
          :prop="fields.lastName.name"
          :required="fields.lastName.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.lastName.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.birthdate.label"
          :prop="fields.birthdate.name"
          :required="fields.birthdate.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-date-picker
              type="date"
              :placeholder="i18n('common.date.formatInput')"
              :format="i18n('common.date.formatInput')"
              v-model="model[fields.birthdate.name]">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.picture.label"
          :prop="fields.picture.name"
          :required="fields.picture.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-image-upload
              :max="fields.picture.max"
              :path="fields.picture.path(currentManage.subproperty.id, playerId)"
              :schema="fields.picture.fileSchema"
              v-model="model[fields.picture.name]"
              :placeholder="i18n('common.uploadFile')"
            ></app-image-upload>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.country.label"
          :prop="fields.country.name"
          :required="fields.country.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-select placeholder filterable v-model="model[fields.country.name]">
              <el-option :value="undefined">--</el-option>
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.country.options"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.gender.label"
          :prop="fields.gender.name"
          :required="fields.gender.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-radio-group v-model="model[fields.gender.name]">
              <el-radio
                :key="option.id"
                :label="option.id"
                v-for="option of fields.gender.options"
              >{{option.label}}</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>

        <!-- program -->
        <el-form-item
          :label="fields.program.label.many"
          :prop="fields.program.name"
          :required="manageInput.program.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-one-input
              :disabled="manageInput.program.disabled"
              :fetchFn="fields.program.fetchFn"
              :key="manageInput.program.key"
              :manage="manageInput.program.values"
              v-model="model[fields.program.name]"
            ></app-autocomplete-one-input>
          </el-col>
        </el-form-item>

        <!-- subprogram -->
        <el-form-item
          :label="fields.subprogram.label"
          :prop="fields.subprogram.name"
          :required="manageInput.subprogram.required"
          v-if="model[fields.program.name]"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-one-input
              :disabled="manageInput.subprogram.disabled"
              :fetchFn="fields.subprogram.fetchFn"
              :key="manageInput.subprogram.key"
              :manage="manageInput.subprogram.values"
              v-model="model[fields.subprogram.name]"
            ></app-autocomplete-one-input>
          </el-col>
        </el-form-item>

        <el-form-item>
          <div class="form-buttons">
            <el-button
              :disabled="saveLoading"
              @click="doSubmit"
              icon="el-icon-fa-floppy-o"
              type="primary"
            >
              <app-i18n code="common.save"></app-i18n>
            </el-button>

            <!-- <el-button :disabled="saveLoading" @click="doReset" icon="el-icon-fa-undo">
              <app-i18n code="common.reset"></app-i18n>
            </el-button> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { PlayerModel } from '@modules/player/player-model';
import objectPath from 'object-path';
import Manage from '@shared/manage/manage-model';
import 'fix-date';

export default {
  name: 'app-player-form-page',

  props: ['id'],

  data() {
    return {
      model: null,
      playerId: null,
       manageInput: {
        program: {
          key: 0,
          required: true,
          values: { type: 'program' },
        },
        subprogram: {
          key: 0,
          required: true,
          values: { type: 'subprogram' },
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'player/form/record',
      findLoading: 'player/form/findLoading',
      saveLoading: 'player/form/saveLoading',
      currentManage: 'auth/manage/currentManage',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    isEditing() {
      return !!this.id;
    },

    rules() {
      const { formSchema } = this;
      return formSchema.rules();
    },
    
    formSchema() {
      const { fields } = this;
      return new FormSchema([
        fields.id,
        fields.teams,
        fields.firstName,
        fields.lastName,
        fields.birthdate,
        fields.picture,
        fields.country,
        fields.gender,
      ]);
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new PlayerModel({ dateFormat, timeFormat }).fields();
    },

    teamPrograms() {
      return (programsObject) => {
        if (!programsObject) return [];
        return Object.keys(programsObject).map((id) => ({
          id,
        }));
      };
    },

    teamSubprograms() {
      return (programsObject) => {
        const subprograms = [];

        if (programsObject) {
          Object.values(programsObject).forEach(
            (programObject) => {
              if (!('subprograms' in programObject)) return;
              if (!programObject.subprograms) return;
              subprograms.push(
                ...Object.keys(programObject.subprograms),
              );
            },
          );
        }

        return subprograms.map((id) => ({ id }));
      };
    },
  },

  async created() {
    const { formSchema } = this;

    this.manageInput.program.values = new Manage(
      this.currentManage,
    ).getManageModel();
    this.manageInput.program.key++;

    if (this.isEditing) {
      await this.doFind(this.id);
      this.model = formSchema.initialValues(this.record);
      this._loadModelPerManage(this.record);
    } else {
      this.playerId = await this.doGetNewId(
        this.currentManage,
      );
      await this.doNew(this.currentManage);
      this.model = formSchema.initialValues(this.record);
    }
  },

  methods: {
    ...mapActions({
      doGetNewId: 'player/form/doGetNewId',
      doFind: 'player/form/doFind',
      doNew: 'player/form/doNew',
      doUpdate: 'player/form/doUpdate',
      doCreate: 'player/form/doCreate',
    }),

    _loadModelPerManage({ programs }) {
      if (!programs) return;

      if (this.teamPrograms(programs).length === 1) {
        objectPath.set(
          this.manageInput,
          'program.disabled',
          true,
        );
        objectPath.set(
          this.manageInput,
          'subprogram.disabled',
          true,
        );
        objectPath.set(this.model, 'program', {
          id: this.teamPrograms(programs)[0].id,
        });

        if (this.teamSubprograms(programs).length === 1) {
          objectPath.set(
            this.manageInput,
            'subprogram.disabled',
            true,
          );
          objectPath.set(this.model, 'subprogram', {
            id: this.teamSubprograms(programs)[0].id,
          });
        }
      }
    },

    doReset() {
      const { formSchema } = this;
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      const { formSchema } = this;
       try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      delete this.model.program;
      delete this.model.subprogram;
      const { id, ...values } = formSchema.cast(this.model);
      // Remove

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
          manage: this.manageInput.subprogram.values,
        });
      } else {
        return this.doCreate({
          id: this.playerId,
          values,
          manage: this.manageInput.subprogram.values,
        });
      }
    },
    // countriesFiltered(countryOptions) {

    //     const countries = ['ES', 'US'];
    //     return countryOptions.filter(({ id }) => {
    //         return countries.some(countryId => countryId === id);
    //     });
    // },
  },

  watch: {
    'model.program.id'(newId) {
      objectPath.set(
        this.manageInput,
        'program.values.programId',
        newId,
      );
      this.manageInput.subprogram.values = this.manageInput.program.values;
      this.manageInput.subprogram.key += 1;
    },
    'model.subprogram.id'(newId) {
      this.manageInput.subprogram.values.subprogramId = newId;
    },
  },
};
</script>

<style>
</style>
